import axios from 'axios'
import AscentiaService from './ascentiaService'
import Qs from 'qs'

const values = {
  analyticResultTypes: null,
  analyticResults: null,
  dAndCData: null,
  maintenanceIssues: null,
  maintenanceRecs: null,
  maintenanceRec: null,
  boxAndWhiskerData: null,
  histogramData: null,
  allRiskScoresByTail: null,
  allRiskScoresByAnalytic: null,
  riskScoreFriendlyNames: null,
  featuresFromRiskScore: null,
  watchlistFeatures: null,
  watchlistRiskScoresFeatures: null,
  alertValues: null,
  analyticSystems: null,
}

let allRiskScoresByTailCall = null

const getters = {
  analyticResultTypes({ id }) {
    return axios.get(`/Analytic/Type/Analytics/${id}`)
  },
  analyticResults({ analytic, resultType, tail }) {
    return axios.get(
      `/Analytic/Values/Type/${analytic}/ResultType/${resultType}/TailNumber/${tail}`,
    )
  },
  dAndCData() {
    return axios.get('/Analytic/DAndC')
  },
  boxAndWhiskerData({
    parameterId,
    flightPhaseId,
    airlineIds,
    startDate,
    endDate,
  }) {
    const airlineIDs = Qs.stringify(
      { airlineIds: airlineIds },
      {
        arrayFormat: 'repeat',
      },
    )

    return axios.get(
      `/FleetCompare/BoxPlot/Parameter/${parameterId}/Phase/${flightPhaseId}?${airlineIDs}&startDate=${startDate}&endDate=${endDate}`,
    )
  },
  maintenanceRecs({ statuses, airline }) {
    let url = '/Analytic/MaintenanceRecs'
    if (airline) {
      url = `/Analytic/${airline}/MaintenanceRecs`
    }

    if (statuses && statuses.length > 0) {
      url += '?'
      for (const statusIdx in statuses) {
        if (statusIdx > 0) {
          url += '&'
        }
        url += `statuses=${statuses[statusIdx]}`
      }
    }
    return axios.get(url)
  },
  maintenanceRec(mxRecId) {
    return axios.get(`/Analytic/MaintenanceRecs/${mxRecId}`)
  },
  allRiskScoresByTail(selectedAirlines) {
    if (allRiskScoresByTailCall) {
      allRiskScoresByTailCall.cancel(
        'Only one group request allowed at a time.',
      )
    }
    allRiskScoresByTailCall = axios.CancelToken.source()
    const list = selectedAirlines.map(airline => {
      return axios.get(`/Analytic/${airline}/AllRiskScoresByTail`, {
        cancelToken: allRiskScoresByTailCall.token,
      })
    })
    return axios.all(list)
  },

  allRiskScoresByAnalytic(airlineId) {
    const url = `/Analytic/${airlineId}/AllRiskScoresByAnalytic`
    return axios.get(url)
  },

  riskScoreFriendlyNames({ id }) {
    const url = `/Analytic/${id}/RiskScoreTypes`
    return axios.get(url)
  },
  featuresFromRiskScore(riskScoreKey) {
    const url = `/Analytic/Features/RiskScore/${riskScoreKey.id}`
    return axios.get(url)
  },
  watchlistFeatures() {
    const url = '/Analytic/Watchlist/Features'
    return axios.get(url)
  },
  watchlistRiskScoresFeatures() {
    const url = '/Analytic/Watchlist/RiskScoresFeatures'
    return axios.get(url)
  },
  alertValues({ tail, startDate, alertKey, airlineId }) {
    let url = `/Analytic/${airlineId}/AlertValues/Tail/${tail}/AlertKey/${alertKey}`
    if (startDate) {
      url += `?start=${startDate}`
    }
    return axios.get(url)
  },
  analyticSystems() {
    const url = '/Analytic/Systems'
    return axios.get(url)
  },
}

const saves = {
  maintRec(maintRec) {
    if (maintRec.id) {
      return axios.put(`/Analytic/MaintenanceRecs/${maintRec.id}`, maintRec)
    } else {
      return axios.post(`/Analytic/MaintenanceRecs`, maintRec)
    }
  },
}

export default class AnalyticService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
}
